<template>
  <div class="fullheight" style="background: #eeeeee">
    <nav class="navbar" role="navigation" aria-label="main navigation">
      <div class="container">
        <div class="navbar-brand">
          <a class="navbar-item" style="padding-top: 10px">
            <img
              src="../../src/assets/img/cardiff-white-text-only.png"
              id="logo"
              height="28"
              alt="cardiff logo"
            />
          </a>
        </div>
      </div>
    </nav>
    <div class="container is-fluid fullheight" id="appcontainer">
      <div class="columns fullheight is-centered">
        <div class="column" id="app-column">
          <transition name="slide" mode="out-in">
            <OfferLoading
              v-if="page == 0"
              key="p0"
              @next="incrementPage"
              :link="$route.params.code"
            />
            <OfferApproval
              v-if="page == 1"
              key="p1"
              @next="incrementPage"
              :approval="approval"
              :name="name"
            />
          </transition>
        </div>
      </div>
    </div>
    <footer class="footer" style="margin-top: 60px" v-if="page != 7">
      <div class="content has-text-centered">
        <img
          src="https://www.bbb.org/globalassets/local-bbbs/canton-oh-76/media/bbb-logos/ab-seal-horizontal-blue.jpg"
          style="max-width: 120px"
          alt="bbb logo"
        />
        <img
          src="https://www.yorkshireghosthunts.co.uk/wp-content/uploads/2016/06/lets-encrypt-seal-secured-ssl-website.png"
          style="max-width: 100px"
        />
        <p style="font-size: 0.675em; margin-top: 10px">
          © 2025 Cardiff, Inc
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import { OfferLoading, OfferApproval } from "@/components/apply/pages";
import { build } from "@/tools/modelBuilder";
export default {
  name: "Offer",
  components: {
    OfferLoading,
    OfferApproval,
  },
  data() {
    return {
      page: 0,
      demo: false,
      model: { name: "" },
      approval: {},
      name: "",
    };
  },
  methods: {
    incrementPage: function (pageData) {
      console.log(pageData);
      this.validate();
      build(this.model, pageData);
      if (pageData.approval) {
        console.log("we have the approval ", pageData.approval);
        this.approval = pageData.approval;
        this.name = pageData.name;
      }
      this.page++;
      window.scrollTo(0, 0);
    },
    validate: function () {
      console.log(this.$route.params.code);
    },
  },
  mounted: function () {
    if (!this.demo) {
      return;
    }
    const self = this;
    setInterval(function () {
      if (self.page === 1) {
        self.page += 2;
      } else if (self.page === 6 || self.page === 3) {
        self.page += 3;
      } else if (self.page < 9) {
        self.page++;
      }
    }, 3000);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar {
  background-color: #3c5cac;
  z-index: 2;
}
.navbar .navbar-brand {
  text-align: center;
  display: block;
  width: 100%;
}

.navbar .navbar-brand > .navbar-item,
.navbar .navbar-brand .navbar-link {
  display: inline-block;
}
@media screen and (min-width: 767px), print {
  .mobile-only {
    display: none;
  }
  .fullheight {
    height: 100%;
  }
  #app-column {
    padding: 50px 120px;
  }
}

@media screen and (max-width: 768px) {
  #cardiff-column {
    display: none;
  }
  #app-column {
    min-height: 100vh;
    padding-top: 50px;
  }
}

#cardiff-column {
  background: #f1f1f1;
  z-index: 1;
  padding-top: 100px;
  max-width: 280px;
}

#logo {
  /* max-width: 50%; */
  margin: auto;
  display: block;
  /* margin-top: 10px; */
  /* margin-bottom: 10px; */
}

.next-button {
  margin-top: 10px;
}

.columns {
  margin-left: 0;
  margin-right: 0;
}

.no-margin {
  margin-bottom: 0px !important;
}
</style>
